
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.681 13.243a3 3 0 00.87-2.351l-.404-5.253a3 3 0 00-2.761-2.76l-5.253-.405a3 3 0 00-2.351.87l-7.51 7.51a3 3 0 000 4.242l5.657 5.657a3 3 0 004.242 0l7.51-7.51zm-6.095-5.925a1.5 1.5 0 102.121 2.121 1.5 1.5 0 00-2.121-2.121zm-4.243 9.192l-2.828-2.828a1 1 0 011.414-1.414l2.829 2.828a1 1 0 01-1.415 1.414z"}})])
          )
        }
      }
    